module.exports = __webpack_public_path__ + "static/media/anvisa-logo.c4b0baa9.png";